var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    ref: "edit",
    attrs: {
      value: _vm.value,
      "characteristic-items": _vm.meta.skill,
      "characteristic-type": _vm.meta.skillType,
      "nothing-allowed": {
        onlyOverall: true,
        overall: {
          inFan: true,
          text:
            "Ich habe keine der angegebenen Persönlichkeitseigenschaften / Sozialen Kompetenzen"
        }
      },
      "selected-items-config": {
        styling: _vm.selectedItemsStylingList
      },
      "open-fan-label":
        "Persönlichkeitseigenschaften / Soziale Kompetenzen hinzufügen/bearbeiten",
      title: "Persönlichkeitseigenschaften / Soziale Kompetenzen",
      "with-edit-button": _vm.withEditButton,
      "header-info": _vm.headerInfo,
      "completion-check-config": {
        enabled: true,
        label: "Persönlichkeitseigenschaften / Soziale Kompetenzen",
        okButtonText: "Ich habe keine weiteren",
        popUpInfo: _vm.completionCheckInfo
      }
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      },
      finish: function($event) {
        return _vm.$emit("finish", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }